/**
 * Website footer
 */

import React, { Component } from "react";

import { Link } from "react-router-dom";

import Contact from "components/Common/ContactModal";

import logo from "../Menu/img/2026-logo.svg";

import facebook from "./img/facebook.svg";
import email from "./img/email.svg";
import youtube from "./img/youtube.svg";
import tiktok from "./img/tiktok.svg";
import vimeo from "./img/vimeo.svg";
import flickr from "./img/flickr.svg";
import instagram from "./img/instagram.png";
import linkedin from "./img/linkedin.png";

import "./index.scss";

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
    };
  }

  toggleModal = (_) =>
    this.setState({
      ...this.state,
      modalOpen: !this.state.modalOpen,
    });

  render() {
    let { modalOpen } = this.state;

    return (
      <div className="Footer">
        <Contact visible={modalOpen} onClose={this.toggleModal} />
        <div className="social-block">
          <img src={logo} alt="" className="logo" />
          <div className="social-icons">
            {/* https://css-tricks.com/use-target_blank/ */}
            <a target="_blank" href="http://www.facebook.com/ILabsRo">
              <img src={facebook} alt="facebook" />
            </a>
<a target="_blank" href="https://www.linkedin.com/company/ilabsro/">
              <img src={linkedin} alt="linkedin" />
            </a>
            <a target="_blank" href="https://www.instagram.com/ilabsro/">
              <img src={instagram} alt="instagram" />
            </a>
<a
              target="_blank"
              href="https://tiktok.com/@ilabs.ro"
            >
              <img src={tiktok} alt="tiktok" />
            </a>
            <a
              target="_blank"
              href="https://www.youtube.com/@innovationlabs1/videos"
            >
              <img src={youtube} alt="youtube" />
            </a>
            
            <a
              target="_blank"
              href="https://www.flickr.com/photos/innovationlabs/albums"
            >
              <img src={flickr} alt="flickr" />
            </a>
            
            <img onClick={this.toggleModal} src={email} alt="email" />
          </div>
        </div>
        <div className="lists-block">
          <ul>
            <li>More</li>
            {/* <li>
              <a href="/">Media kit</a>
            </li> */}
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://shorturl.at/lyIJ0"
              >
                Terms and Conditions
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://docs.google.com/document/d/e/2PACX-1vR8Vm3e_Sy9jBJxiymhduAgm0A8Mvzpcyc5CWcmOIKyamVFONvuPMobHdFHYUd9Sw/pub"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://shorturl.at/mAXZ8"
              >
                EGV Term Sheet
              </a>
            </li>
          </ul>
          <ul>
            <li>Partners</li>
            <li>
              <a href="https://ye35yotivr1.typeform.com/IlabsCommunity">
                Want to become a partner ?
              </a>
            </li>

            <li>
              <Link to="/whoweare/Board">Board members</Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Footer;
